<template>
  <div
    class="
      justify-content-md-center
      p-3
      d-flex
      flex-column
      justify-content-between
      h-100
    "
    :style="
      userData.isAndroid
        ? ' background-color: rgb(249, 250, 252) !important '
        : 'overflow-y: scroll; background-color: rgb(249, 250, 252) !important'
    "
  >
    <div>
      <b-row class="">
        <b-col>
          <div class="row" style="">
            <div
              class="
                offset-2
                col-8
                offset-md-1
                col-md-10
                justify-content-center
                align-self-center
              "
            >
              <template>
                <b-img-lazy
                  class="image w-100"
                  :src="imgDStatement"
                  width="240"
                  height="168"
                />
              </template>
            </div>
          </div>
        </b-col>
        <div class="w-100 my-3" />
        <b-col>
          <span class="text-ktb-bold-20">บริการ dStatement คืออะไร?</span>
        </b-col>
        <div class="w-100 my-1" />
        <b-col>
          <span class="text-ktb-regular-16-grey"
            >บริการขอ Statement จากธนาคารอื่นผ่านทางระบบ National Digital ID
            หรือ NDID สําหรับการให้บริการทางการเงินดิจิทัล</span
          >
        </b-col>
        <div class="w-100 mb-3" />
        <b-col>
          <span class="text-ktb-regular-16-grey"
            >เพื่อช่วยอํานวยความสะดวกให้คุณสมัครบริการผ่านช่องทางออนไลน์
            โดยไม่ต้องเดินทางไปสาขา
            บริการนี้มีค่าธรรมเนียมที่ถูกเรียกเก็บจากธนาคารเจ้าของบัญชี</span
          >
        </b-col>
        <div class="w-100 border-top-NEXT my-3 mx-3" />
        <b-col>
          <span class="text-ktb-bold-20 my-3">อัตราค่าธรรมเนียม</span>
        </b-col>
        <div class="w-100 my-1" />
        <b-col>
          <span class="text-ktb-regular-16-grey"
            >การขอ dStatement
            จะมีการเรียกเก็บค่าธรรมเนียมจากธนาคารเจ้าของบัญชีที่คุณเลือก</span
          >
        </b-col>
      </b-row>
      <b-card class="border-radius-1rem my-3" body-class="p-3">
        <div v-for="(item, key) in lstBankDstatement" :key="key">
          <div :class="key != 0 ? 'border-bottom-NEXT my-3' : ''"></div>
          <b-row class="custom-bank-row">
            <b-col align-self="center" cols="2">
              <b-img-lazy
                :src="showLogoBank[item.bank_code]"
                center
                width="40"
                height="40"
              />
            </b-col>
            <b-col
              align-self="center"
              cols="5"
              class="text-left text-ktb-regular-16"
              ><span style="letter-spacing: -0.5px !important"
                ><b>{{ item.marketing_name_th }}</b></span
              ></b-col
            >
            <b-col
              align-self="center"
              cols="5"
              class="text-right text-ktb-bold-16"
              ><span v-if="item.min_price != item.max_price"
                ><b
                  >{{ item.min_price }}-{{ item.max_price }} บาท/บัญชี</b
                ></span
              >
              <span v-else
                ><b>{{ item.min_price }} บาท/บัญชี</b></span
              ></b-col
            >
            <div
              v-if="
                key <
                lstBankDstatement.filter((item) => item.active_flag).length - 1
              "
              class="w-100 border-top-NEXT my-3"
            />
          </b-row>
        </div>
      </b-card>
      <b-row>
        <b-col
          ><span class="text-ktb-regular-16-grey"
            >คุณสามารถขอ dStatement ได้อีก
            {{ countRequestStatement }} ครั้ง</span
          ></b-col
        >
        <div class="w-100" />
        <b-col cols="auto" class="d-flex justify-content-center my-3">
          <div class="custom-control custom-checkbox">
            <input
              v-model="dStatementSelected"
              :disabled="userData.dStatementSelected"
              type="checkbox"
              class="custom-control-input"
              id="customCheck1"
            />
            <label class="custom-control-label" for="customCheck1"></label>
          </div>
          <div class="px-3" style="vertical-align: middle; line-height: 32px">
            <span class="text-ktb-regular-16"
              >ขอ Statement จากธนาคารอื่น(dStatement)</span
            >
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="">
      <b-row v-if="!checkStateSuccess">
        <b-col class="py-3" align-self="center">
          <button
            v-show="!userData.dStatementSelected"
            @click="getAlertDetail()"
            class="btn btn-info btn-block btn-ktb-NEXT"
            :disabled="checkSelected()"
          >
            {{ "ถัดไป" }}
          </button>
          <button
            v-show="userData.dStatementSelected"
            @click="cancel()"
            class="btn btn-info btn-block btn-ktb-NEXT btn-cancel-dstatement"
          >
            {{ "ยกเลิก dStatement" }}
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    let currentMenu = {
      pageCode: "CommonDstatement",
      pageName: "บริการ dStatement",
      previousPage: this.userData.routerPath.documentGroup,
      params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
    };
    this.$event.$emit("update_current_menu", currentMenu);
    if (this.userData.dStatementSelected != undefined) {
      this.dStatementSelected = this.userData.dStatementSelected;
    }
    if (this.$route.params.checkDocIsSuccess != undefined) {
      this.checkStateSuccess = this.$route.params.checkDocIsSuccess;
    }
    if (
      this.userData.lstPriceAs !== undefined &&
      this.userData.lstPriceAs.length > 0
    )
      this.lstBankDstatement = this.userData.lstPriceAs;

    if (this.userData.countRequestStatement !== undefined)
      this.countRequestStatement = this.userData.countRequestStatement;
    this.scaleUpCheckbox();
  },
  data() {
    return {
      checkStateSuccess: false,
      dStatementSelected: false,
      countRequestStatement: 1,
      imgDStatement: require("@/assets/images/Requesting dStatement@3x.png"),
      showLogoBank: {
        ANZ: require("@/assets/images/BankLogo/ANZ.png"),
        BAAC: require("@/assets/images/BankLogo/BAAC.png"),
        BAY: require("@/assets/images/BankLogo/BAY.png"),
        BKK: require("@/assets/images/BankLogo/BKK.png"),
        BNP: require("@/assets/images/BankLogo/BNP.png"),
        BOC: require("@/assets/images/BankLogo/BOC.png"),
        CIMBT: require("@/assets/images/BankLogo/CIMBT.png"),
        CITI: require("@/assets/images/BankLogo/CITI.png"),
        DB: require("@/assets/images/BankLogo/DB.png"),
        GHB: require("@/assets/images/BankLogo/GHB.png"),
        GSB: require("@/assets/images/BankLogo/GSB.png"),
        HSBC: require("@/assets/images/BankLogo/HSBC.png"),
        ICBCT: require("@/assets/images/BankLogo/ICBCT.png"),
        IOBA: require("@/assets/images/BankLogo/IOBA.png"),
        ISBT: require("@/assets/images/BankLogo/ISBT.png"),
        KBANK: require("@/assets/images/BankLogo/KBANK.png"),
        KK: require("@/assets/images/BankLogo/KK.png"),
        KKP: require("@/assets/images/BankLogo/KKP.png"),
        KTB: require("@/assets/images/BankLogo/KTB.png"),
        LHB: require("@/assets/images/BankLogo/LHB.png"),
        ME: require("@/assets/images/BankLogo/ME.png"),
        MIZUHO: require("@/assets/images/BankLogo/MIZUHO.png"),
        Placeholder: require("@/assets/images/BankLogo/Placeholder.png"),
        SCB: require("@/assets/images/BankLogo/SCB.png"),
        SCBT: require("@/assets/images/BankLogo/SCBT.png"),
        SMBC_2: require("@/assets/images/BankLogo/SMBC 2.png"),
        SMBC: require("@/assets/images/BankLogo/SMBC.png"),
        TBANK: require("@/assets/images/BankLogo/TBANK.png"),
        TCR: require("@/assets/images/BankLogo/TCR.png"),
        TISCO: require("@/assets/images/BankLogo/TISCO.png"),
        TTB: require("@/assets/images/BankLogo/TTB.png"),
        UOB: require("@/assets/images/BankLogo/UOB.png")
      },
      lstBankDstatement: [
        {
          bank_code: "BKK",
          marketing_name_th: "กรุงเทพ",
          min_price: 0,
          max_price: 75,
        },
        {
          bank_code: "BAY",
          marketing_name_th: "กรุงศรีอยุธยา",
          min_price: 0,
          max_price: 75,
        },
        {
          bank_code: "KBANK",
          marketing_name_th: "กสิกรไทย",
          min_price: 0,
          max_price: 75,
        },
      ],
    };
  },
  methods: {
    goback() {
      this.userData.dStatementSelected = this.dStatementSelected;
      this.$store.dispatch("setUserData", this.userData);
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    cancel() {
      this.dStatementSelected = false;
      this.goback();
    },
    checkSelected() {
      return !this.dStatementSelected;
    },
    getAlertDetail() {
      this.$swal
        .fire({
          imageUrl: require("@/assets/images/foundationIllustrationGenericInformation@3x.png"),
          position: "bottom",
          title:
            "ระบบจะพาคุณไปขอ dStatement หลังจากที่คุณส่งเอกสารอื่นเรียบร้อยแล้ว",
          text: "คุณสามารถยกเลิกการขอ dStatement ได้ภายหลัง",
          width: 300,
          padding: "1em",
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title: "text-ktb-bold-16 dstatement-popup",
            confirmButton:
              "btn rounded-pill btn-block font-weight-bold btn-ktb-NEXT swal-button-info btn-padding",
            popup: "swal2-modal-NEXT",
            image: "swal2-image-NEXT",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.goback();
          }
        });
    },
    scaleUpCheckbox() {
      document.styleSheets[0].addRule(
        "custom-control-label:before",
        "width: 24px"
      );
    },
  },
};
</script>
<style scoped>
.btn-cancel-dstatement {
  color: rgb(219, 0, 0) !important;
  border-color: rgb(219, 0, 0) !important;
  background-color: white !important;
  background-image: unset !important;
}
.custom-bank-row {
  position: relative;
  height: 48px;
}
.custom-control-label::before {
  width: 24px !important;
  height: 24px !important;
}
.custom-control-label::after {
  width: 24px !important;
  height: 24px !important;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-image: url("~@/assets/icons/svg/correct-white.svg") !important;
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: #bdcbd6 !important;
  border-color: #bdcbd6 !important;
}

.custom-checkbox .custom-control-input:disabled~.custom-control-label::before {
  background-color: #bdcbd6 !important;
  border-color: #bdcbd6 !important;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
  border: rgb(0, 166, 230) solid 1px !important;
}

.custom-control-input:checked~.custom-control-label::before {
  border-color: #03a5e6 !important;
  background-color: #03a5e6 !important;
}
</style>
